import { ThemeAttributesMap } from '@kata-kit/theme';
import button from './themes/Button';

const themes: Record<string, ThemeAttributesMap> = {
  button
};

export default themes;
